<template>
  <div></div>
</template>

<script>
export default {
  name: "BasketItemUtils",
  methods: {
    changeQuantity: function (quantity) {
      this.$store.dispatch({
        type: 'order/changeQuantity',
        code: this.item.code,
        quantity: quantity,
        sauces: this.item.sauces,
      });
    },
    changeComboQuantity: function (quantity, comboCode) {
      this.$store.dispatch({
        type: 'order/changeQuantity',
        code: comboCode,
        quantity: quantity
      });
    }
  },
}
</script>

<style scoped>

</style>
